import React from 'react';
import PropTypes from "prop-types";
import classnames from "classnames";
import {Field} from "formik";

function Input (props) {
    const placeholder = props.required ? props.placeholder + "*" : props.placeholder;
    const errors = props.errors;

    return (
        <>
            <div className={classnames("input-section input-section--text", {
                "is-invalid" : errors !== undefined,
            })}>
                <div className="d-flex">
                    <div className={classnames("input-group", {
                        "has-error" : errors,
                    })}>
                        {errors !== undefined ? (
                            <div className="error-label">
                                <span>Let op!</span>
                                <span className="error-message">{errors}</span>
                            </div>
                        ) : null}
                        <Field
                            type="text"
                            className="form-control"
                            name={props.name}
                            placeholder={placeholder}
                            required={props.required}
                        />
                        <label>{placeholder}</label>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Input;

Input.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    errors: PropTypes.string,
};